<!-- GRID de 2 columnas -->
<div class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2">
  <!-- Obtenemos banners para el país, tipo de usuario y lenguaje -->
  <ng-container *ngIf="banners">
    <!-- Si banners tiene bylanguage, seleccionamos el idioma del usuario -->

      <ng-container *ngIf="userInfo?.language as lang">
        <ng-container *ngIf="banners as banners">
          <!-- Banner 1 -->
          <div *ngIf="banners?.bannerBottomLeftImageUrl">
            <a [href]="banners.bannerBottomLeftLink" class="block text-center mt-2">
              <picture>
                <source media="(max-width: 767px)" [srcset]="banners.bannerBottomLeftSmallImageUrlXs" />
                <source media="(min-width: 768px) and (max-width: 1024px)" [srcset]="banners.bannerBottomLeftSmallImageUrl" />
                <source media="(min-width: 1025px)" [srcset]="banners.bannerBottomLeftImageUrl" />
                <img
                  [src]="banners.bannerBottomLeftImageUrl"
                  class="w-full h-auto"
                />
              </picture>
            </a>
          </div>
          <!-- Banner 2 -->
          <div *ngIf="banners.bannerBottomRightImageUrl">
            <a [href]="banners.bannerBottomRightLink" class="block text-center mt-2">
              <picture>
                <source media="(max-width: 767px)" [srcset]="banners.bannerBottomRightSmallImageUrlXs" />
                <source media="(min-width: 768px) and (max-width: 1024px)" [srcset]="banners.bannerBottomRightSmallImageUrl" />
                <source media="(min-width: 1025px)" [srcset]="banners.bannerBottomRightImageUrl" />
                <img
                  [src]="banners.bannerBottomRightImageUrl"
                  class="w-full h-auto"
                />
              </picture>
            </a>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

  <!-- opcional: mostrar fallback si no hay banners -->
  <div *ngIf="!banners">
    <!-- contenido alternativo o dejar vacío -->
  </div>
</div>

<!-- POPUP pantalla completa -->
<ng-container *ngIf="banners">
  <ng-container *ngIf="userInfo?.language as lang">
    <ng-container *ngIf="banners as banners">
      <div
        *ngIf="(banners?.popup1ImageUrl || banners?.popup2ImageUrl) && showPopup"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
      >
        <div class="relative w-full h-full flex items-center justify-center">
          <!-- Popup 1 -->
          <ng-container *ngIf="banners?.popup1ImageUrl && showPopup1">
            <a [href]="banners.popup1ImageUrl" class="block text-center">
              <img
                [src]="banners.popup1ImageUrl"
                class="max-w-full max-h-full"
              />
            </a>
          </ng-container>
          <!-- Popup 2 -->
          <ng-container *ngIf="banners?.popup2ImageUrl && showPopup2">
            <a [href]="banners.popup2ImageUrl" class="block text-center">
              <img
                [src]="banners.popup2ImageUrl"
                class="max-w-full max-h-full"
              />
            </a>
          </ng-container>
          <!-- Botón cerrar -->
          <button
            (click)="closePopup()"
            class="absolute top-4 right-4 text-white text-2xl bg-black bg-opacity-50 rounded-full px-3 py-1"
            aria-label="Cerrar"
          >
            &times;
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>



